import React from "react";
import { makeStyles } from "@mui/styles";

const styles = makeStyles({
  dropdown: {
    appearance: "none",
    border: "1px solid #D3DAE3",
    padding: "0 0.8rem",
    borderRadius: "4px",
    color: "#626B7E",
    width: "100%",
    fontFamily: "inter_400",
    fontSize: "13px",
    background: "transparent url('http://localhost:3000/assets/icons/Polygon.svg') no-repeat 95%",
    objectFit: "cover",
    minHeight: "6vh",
    height: "100%",
    margin: 0,
    "@media (max-width: 768px)": {
      minWidth: "20vw",
    },
  },
});

const CustomDropDown = ({
  items,
  backgroundColor,
  fontFamily,
  iconPercent,
  ...props
}) => {
  const classes = styles();

  return (
    <select
      {...props}
      className={classes.dropdown}
      style={{
        fontFamily: fontFamily && fontFamily,
        background: iconPercent
          ? `transparent url('http://localhost:3000/assets/icons/Polygon.svg') no-repeat ${iconPercent}`
          : null,
        backgroundColor: backgroundColor ? backgroundColor : null,
      }}
    >
      {items?.length
        ? items.map((item) => {
            return (
              <option key={item} value={item}>
                {item}
              </option>
            );
          })
        : null}
    </select>
  );
};

export default CustomDropDown;
